import React, { Component } from 'react';
import { AppContext } from '../../context/AppContext';
import { logoutRequest } from '../../services/authService';

class Header extends Component {
  static contextType = AppContext;

  getSelectedBusinessName = () => {
    const contextValue = this.context || {};
    const state = contextValue.state || {};
    const businesses = state.businesses || [];
    const selectedBusinessId = state.selectedBusinessId || '';

    if (!selectedBusinessId || !businesses.length) {
      return 'לא נבחר עסק';
    }

    const selectedBusiness = businesses.find(
      (business) => business.id === selectedBusinessId
    );

    return selectedBusiness ? selectedBusiness.name : 'לא נבחר עסק';
  };

  handleBusinessChange = (event) => {
    const contextValue = this.context || {};
    const dispatch = contextValue.dispatch;

    if (!dispatch) {
      return;
    }

    dispatch({
      type: 'SET_SELECTED_BUSINESS',
      payload: event.target.value,
    });
  };

  handleLogout = () => {
    const contextValue = this.context || {};
    const dispatch = contextValue.dispatch;

    logoutRequest()
      .finally(() => {
        localStorage.clear();

        if (dispatch) {
          dispatch({
            type: 'LOGOUT',
          });
        }

        window.location.href = '/login';
      });
  };

  render() {
    const contextValue = this.context || {};
    const state = contextValue.state || {};
    const owner = state.owner || null;
    const businesses = state.businesses || [];
    const selectedBusinessId = state.selectedBusinessId || '';

    return (
      <header className="app-header">
        <div className="app-header-left">
          <div className="app-header-title">MBVIP Dashboard</div>
        </div>

        <div className="app-header-center">
          <div className="header-business-block">
            <label className="header-business-label">עסק פעיל</label>
            <select
              className="header-business-select"
              value={selectedBusinessId}
              onChange={this.handleBusinessChange}
            >
              <option value="">בחר עסק</option>
              {businesses.map((business) => (
                <option key={business.id} value={business.id}>
                  {business.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="app-header-right">
          <div className="header-user-info">
            <div className="header-user-name">
              {owner ? owner.name : 'משתמש'}
            </div>
            <div className="header-user-business">
              {this.getSelectedBusinessName()}
            </div>
          </div>

          <button type="button" className="header-logout-btn" onClick={this.handleLogout}>
            יציאה
          </button>
        </div>
      </header>
    );
  }
}

export default Header;